import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Grid, Typography, IconButton, Tooltip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import Card from '../../../../../../components/Card';
import Input from '../../../../../../components/Input';
import Modal from '../../../../../../components/Modal';
import Button from '../../../../../../components/Button';

const UNLOCK_TARGET = {
  CREDENTIALS: 'credentials',
  TOKEN: 'token'
}

export default function Authentication({ formikProps }) {
  const {
    configType,
    isRpsConfig,
    dataPage,
    basicInfo: {
      cityCode
    },
    authentication: {
      certificate: isCertificate,
      login: isLogin,
      password: isPassword
    }
  } = useSelector(state => state.provisionalReceiptConfig);

  const [unlockTarget, setUnlockTarget] = useState(null);

  const isSameCnpj = +configType == 0;
  const isNfseNational = +cityCode == 9999999;
  const isCredentialsUnlocked = !!formikProps.values.isCredentialsUnlocked;
  const isTokenUnlocked = !!formikProps.values.isTokenUnlocked;
  // Cadastro: campos editáveis (respeitando isSameCnpj). Edição: bloqueados até desbloquear.
  const areCredentialsDisabled = isSameCnpj || (isRpsConfig && !isCredentialsUnlocked);
  const isTokenDisabled = isSameCnpj || (isRpsConfig && !isTokenUnlocked);

  useEffect(() => {
    if(!!formikProps?.errors?.autenticatorToken || !!formikProps?.errors?.autenticatorUser || !!formikProps?.errors?.autenticatorUserPassword) {
      toast.error('Preencha o campo de autenticação para avançar.');
    }
  }, [formikProps?.errors]);

  const handleOpenUnlockModal = target => {
    setUnlockTarget(target);
  }

  const handleCloseUnlockModal = () => {
    setUnlockTarget(null);
  }

  const handleConfirmUnlock = () => {
    if(unlockTarget == UNLOCK_TARGET.CREDENTIALS) {
      formikProps.setFieldValue('isCredentialsUnlocked', true);
      formikProps.setFieldValue('autenticatorUserPassword', '');
    }

    if(unlockTarget == UNLOCK_TARGET.TOKEN) {
      formikProps.setFieldValue('isTokenUnlocked', true);
      formikProps.setFieldValue('autenticatorToken', '');
    }

    setUnlockTarget(null);
  }

  const handleLockCredentials = () => {
    formikProps.setFieldValue('isCredentialsUnlocked', false);
  }

  const handleLockToken = () => {
    formikProps.setFieldValue('isTokenUnlocked', false);
  }

  const getLockAction = ({ isUnlocked, onLock, onUnlock, lockLabel, unlockLabel }) => {
    if(!isRpsConfig) {
      return null;
    }

    return(
      <Grid item style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip
          arrow
          placement="top"
          title={isUnlocked ? lockLabel : unlockLabel}
        >
          <IconButton
            type="button"
            onClick={isUnlocked ? onLock : onUnlock}
            size="small"
            aria-label={isUnlocked ? lockLabel : unlockLabel}
          >
            <FontAwesomeIcon
              icon={isUnlocked ? faLockOpen : faLock}
              color="#757575"
              size="sm"
            />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  }

  const getUserAndPasswordFields = () => {
    if(isCertificate && isLogin && !isPassword) {
      return(
        <Card title="Usuário" style={{ marginTop: 20, marginBottom: 20 }}>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs>
                <Input
                  disabled={areCredentialsDisabled}
                  name="autenticatorUser"
                  type="user"
                  label="Usuário"
                  value={formikProps.values.autenticatorUser || ""}
                  error={formikProps.errors.autenticatorUser}
                  helperText={formikProps.errors.autenticatorUser}
                  onChange={e => formikProps.handleChange(e)}
                />
              </Grid>
              {getLockAction({
                isUnlocked: isCredentialsUnlocked,
                onLock: handleLockCredentials,
                onUnlock: () => handleOpenUnlockModal(UNLOCK_TARGET.CREDENTIALS),
                lockLabel: 'Bloquear edição de usuário e senha',
                unlockLabel: 'Desbloquear para editar usuário e senha'
              })}
            </Grid>
          </Grid>
        </Card>
      );
    }

    if(isLogin || isPassword) {
      return(
        <Card title="Usuário e senha" style={{ marginTop: 20, marginBottom: 20 }}>
          {dataPage && !!dataPage.helpTipoAutenticacao && (
            <Grid
              container
              style={{
                flexDirection: 'column',
                padding: 15,
                backgroundColor: 'rgb(241, 244, 249)',
                border: '1px solid #38a8d8',
                borderRadius: 10
              }}
            >
              <Grid item spacing={2}>
                <Typography variant="h6" color="primary">
                  Atenção:
                </Typography>
                <Typography
                  variant="h6"
                  style={{ fontWeight: 400, fontSize: '15px' }}
                >
                  {dataPage && dataPage.helpTipoAutenticacao.usuario}
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item sm xs={12}>
                <Input
                  disabled={areCredentialsDisabled}
                  name="autenticatorUser"
                  type="user"
                  label="Usuário"
                  value={formikProps.values.autenticatorUser || ""}
                  error={formikProps.errors.autenticatorUser}
                  helperText={formikProps.errors.autenticatorUser}
                  onChange={e => formikProps.handleChange(e)}
                />
              </Grid>
              <Grid item sm xs={12}>
                <Input
                  disabled={areCredentialsDisabled}
                  name="autenticatorUserPassword"
                  type="password"
                  label="Senha"
                  value={formikProps.values.autenticatorUserPassword || ""}
                  error={formikProps.errors.autenticatorUserPassword}
                  helperText={formikProps.errors.autenticatorUserPassword}
                  onChange={formikProps.handleChange}
                />
              </Grid>
              {getLockAction({
                isUnlocked: isCredentialsUnlocked,
                onLock: handleLockCredentials,
                onUnlock: () => handleOpenUnlockModal(UNLOCK_TARGET.CREDENTIALS),
                lockLabel: 'Bloquear edição de usuário e senha',
                unlockLabel: 'Desbloquear para editar usuário e senha'
              })}
            </Grid>
          </Grid>
        </Card>
      );
    }

    return(
      <></>
    );
  }

  if(isNfseNational) {
    return(
      <></>
    );
  }

  return(
    <>
      {!!unlockTarget && (
        <Modal
          title="Atenção"
          open={!!unlockTarget}
          onClose={handleCloseUnlockModal}
          modalActions={
            <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Grid item>
                <Button
                  color="tertiary"
                  variant="outlined"
                  onClick={handleCloseUnlockModal}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  onClick={handleConfirmUnlock}
                >
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          }
        >
          <Typography color="textSecondary">
            Não armazenamos token ou senha da sua empresa, caso deseje editar vai ser necessário preencher essa informação do zero.
          </Typography>
        </Modal>
      )}
      {(isPassword && !isLogin) && !!formikProps.values.cityCode && (
        <Card title="Token ou chave de Acesso" style={{ marginTop: 20, marginBottom: 20 }}>
          <Grid item xs={12}>
            <Grid
              container
              style={{
                flexDirection: 'column',
                padding: 15,
                backgroundColor: 'rgb(241, 244, 249)',
                border: '1px solid #38a8d8',
                borderRadius: 10
              }}
            >
              <Grid item spacing={2}>
                <Typography variant="h6" color="primary">
                  Atenção:
                </Typography>
                <Typography
                  variant="h6"
                  style={{ fontWeight: 400, fontSize: '15px' }}
                >
                  Para obtê-la acesse o portal da NFS-e da prefeitura e após se
                  autenticar vá no menu Notas Fiscais na opção Web Service -
                  Gerar Chave Autenticação. Clique em "Gerar Chave".
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs>
                <Input
                  disabled={isTokenDisabled}
                  name="autenticatorToken"
                  type="text"
                  label="Chave de acesso"
                  value={formikProps.values.autenticatorToken || ""}
                  error={formikProps.errors.autenticatorToken}
                  helperText={formikProps.errors.autenticatorToken}
                  onChange={formikProps.handleChange}
                />
              </Grid>
              {getLockAction({
                isUnlocked: isTokenUnlocked,
                onLock: handleLockToken,
                onUnlock: () => handleOpenUnlockModal(UNLOCK_TARGET.TOKEN),
                lockLabel: 'Bloquear edição do token',
                unlockLabel: 'Desbloquear para editar o token'
              })}
            </Grid>
          </Grid>
        </Card>
      )}
      {!!formikProps.values.cityCode && getUserAndPasswordFields()}
    </>
  );
}